module.exports = __webpack_public_path__ + "img/arc.e0d0c430.svg";